<template>
  <div style="position: relative" v-click-outside="close">

    <div class="label-participants">
      <span>
        <span v-for="(participant, index) in participants" :key="participant.id">
          <template v-if="index < 2">
            <span class="nowrap">
              <strong>{{ buildTypeParticipant(participant) }}:</strong> {{ participant.name }} - {{ participant.cnpj | cnpj}}
            </span><br>
          </template>
        </span>
      </span>

      <span v-if="participants.length > 2" @click="showParticipant(true)" class="ml-2 plus-icon nowrap">
        <PlusIcon size="1x"/>
        {{ participants.length - 2}}
      </span>
    </div>

    <div class="modal-participants" v-if="show">
      <span v-for="participant in participants" :key="participant.id">
        <template>
          <strong>
            {{ buildTypeParticipant(participant) }}:
          </strong>

           {{ participant.name }} -
           {{ participant.cnpj | cnpj }}
          <br>
        </template>
      </span>
      <XIcon class="close" @click="showParticipant(false)"/>
    </div>

  </div>
</template>

<script>
  import { PlusIcon, XIcon } from 'vue-feather-icons'
  import ClickOutside from 'vue-click-outside'

  export default {
    components: { PlusIcon, XIcon },
    created() {
      this.participants.sort((a, b) =>(a.type > b.type) ? 1 : ((b.type > a.type) ? -1 : 0))
    },
    data() {
      return {
        show: false
      }
    },
    directives: { ClickOutside },
    methods: {
      buildTypeParticipant(participant) {
        const types = {
          dispatcher: 'Expedidor',
          issuer: 'Emitente',
          provider: 'Fornecedor',
          receiver: 'Recebedor',
          recipient: 'Destinatário',
          sender: 'Remetente',
          taker: 'Tomador',
          transporter: 'Transportador'
        }
        return types[participant.participantType]
      },
      close() {
        this.show = false
      },
      showParticipant(value) {
        this.show = value
      }
    },
    mounted() {
      this.popupItem = this.$el
    },
    name: 'ModalParticipants',
    props: {
      participants: { required: true, type: Array }
    }
  }
</script>

<style scoped>

  .label-participants {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .modal-participants {
    position: absolute;
    background-color: white;
    white-space: nowrap;
    top: 0;
    right: 0;
    padding: 16px;
    z-index: 1;
    border-radius: 10px;
    box-shadow: 0px 0px 5px 2px rgba(0, 0, 0, 0.2);
    overflow: auto;
  }

  .modal-participants .close {
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
  }

  .plus-icon {
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    background: #ececec;
  }

  .plus-icon:hover {
    background: #c3c3c3;
  }

</style>
